import * as types from './actionTypes'
import { payrollNormalWorkHourService } from '../_services'

export function fetchPayrollNormalWorkHours(data) {
    return dispatch => {
        return payrollNormalWorkHourService
            .getPayrollNormalWorkHours(data)
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_EMP_NORMAL_WORKHOUR, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_EMP_NORMAL_WORKHOUR_FAILURE, error }
    }
}